import { Ship } from "./ship";

export class Record {
  id?: number;
  location?: string;
  registerDate?: Date;
  ship?: Ship;
  status?: number;
  observation?: string;
}
